import { connect } from 'react-redux'

import { push } from '@lagunovsky/redux-react-router'
import { removeCard, setCardProlonge } from '../../../../components/Basket/reducer'
import { registerClub } from '../../../../components/Forms/FormRegisterClub/reducer'
import { findCinemaId } from '../../../../global/helpers'

const mapStateToProps = (state) => {
    const cinemaid = findCinemaId(state)

    return {
        cinemaid,
        cardsInBasket: state?.components?.basket?.data?.items_cards,
    }
}

const mapDispatchToProps = { setCardProlonge, removeCard, registerClub, push }

const hocClubCard = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocClubCard
